export const STRIPE_KEY: string = process.env.REACT_APP_STRIPE_KEY || "";
export const BASE_API_URL: string = process.env.REACT_APP_BASE_API_URL || "";
export const RECAPTCHA_SITE_KEY: string = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
export const EASTER_EGG: string = process.env.REACT_APP_EASTER_EGG || "";
export const INTERCOM_APP_ID: string = process.env.REACT_APP_INTERCOM_APP_ID || "";

if (STRIPE_KEY === "") {
  throw Error("NO STRIPE KEY");
}

if (BASE_API_URL === "") {
  throw Error("NO BASE API URL");
}
